if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      const inventoryData = this.querySelector('[data-variant-inventory]');
      try {
        this.variantInventory = inventoryData ? JSON.parse(inventoryData.textContent) : {};
      } catch (e) {
        this.variantInventory = {};
      }
    }

    // Returns how many more units of the variant can go into the cart, or null when stock is not limited.
    async getAvailableQuantity(variantId) {
      const inventory = this.variantInventory[variantId];
      if (inventory === undefined) return null;

      try {
        const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
        const quantityInCart = cart.items
          .filter((item) => String(item.variant_id) === String(variantId))
          .reduce((total, item) => total + item.quantity, 0);
        return Math.max(inventory - quantityInCart, 0);
      } catch (e) {
        return null;
      }
    }

    resetQuantityInput() {
      const quantityInput =
        this.querySelector('.quantity__input') ||
        (this.form && document.querySelector(`.quantity__input[form="${this.form.id}"]`));
      if (!quantityInput) return;

      quantityInput.value = 1;
      quantityInput.setAttribute('value', 1);
      const quantityElement = quantityInput.closest('quantity-input');
      if (quantityElement && typeof quantityElement.setMinimumDisable === 'function') quantityElement.setMinimumDisable();
    }

    showLimitedQuantityMessage(variantId, quantity) {
      const message = window.cartStrings.partialAdd.replace('[quantity]', quantity);
      this.handleErrorMessage(message);

      const lineItemError = this.cart && this.cart.querySelector(`[data-variant-id="${variantId}"] .cart-item__error`);
      if (!lineItemError) return;
      lineItemError.classList.remove('hidden');
      const errorText = lineItemError.querySelector('.cart-item__error-text');
      if (errorText) errorText.textContent = message;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      // Never request more than the stock left for this variant: add only what is available.
      const variantId = formData.get('id');
      const requestedQuantity = parseInt(formData.get('quantity')) || 1;
      const availableQuantity = await this.getAvailableQuantity(variantId);
      const limitedQuantity =
        availableQuantity !== null && availableQuantity > 0 && requestedQuantity > availableQuantity ? availableQuantity : null;
      if (limitedQuantity !== null) formData.set('quantity', limitedQuantity);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          this.resetQuantityInput();
          const renderCart = () => {
            this.cart.renderContents(response);
            if (limitedQuantity !== null) this.showLimitedQuantityMessage(variantId, limitedQuantity);
          };
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(renderCart);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            renderCart();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
